(function () {
  'use strict';

  function loadCategories() {
    try {
      var el = document.getElementById('ferre-collection-data');
      if (el) return JSON.parse(el.textContent);
    } catch (e) {}
    return [
      { code: 'TO', name: 'Tornillería',             count: '—', handle: 'tornilleria' },
      { code: 'PI', name: 'Pintura y Brochas',       count: '—', handle: 'pintura-y-brochas' },
      { code: 'TU', name: 'Tubería y Conexiones',    count: '—', handle: 'tuberia-y-conexiones' },
      { code: 'CO', name: 'Herramienta de Corte',    count: '—', handle: 'herramienta-de-corte' },
      { code: 'CA', name: 'Cables y Contactos',      count: '—', handle: 'cables-y-contactos' },
      { code: 'CE', name: 'Candados y Cerraduras',   count: '—', handle: 'candados-y-cerraduras' },
      { code: 'AD', name: 'Cinta y Adhesivos',       count: '—', handle: 'cinta-y-adhesivos' },
      { code: 'ME', name: 'Medición y Trazado',      count: '—', handle: 'medicion-y-trazado' },
      { code: 'EP', name: 'Guantes y EPP',           count: '—', handle: 'guantes-y-epp' },
      { code: 'FO', name: 'Focos y Lámparas',        count: '—', handle: 'focos-y-lamparas' }
    ];
  }

  var CATEGORIES = loadCategories();

  var BRANDS = [
    { name: 'Truper',    handle: 'truper' },
    { name: 'Pretul',    handle: 'pretul' },
    { name: 'Urrea',     handle: 'urrea' },
    { name: 'Avante',    handle: 'avante' },
    { name: 'Bosch',     handle: 'bosch' },
    { name: 'Dewalt',    handle: 'dewalt' },
    { name: 'Volteck',   handle: 'volteck' },
    { name: 'Stanley',   handle: 'stanley' },
    { name: 'Surtek',    handle: 'surtek' },
    { name: '3M',        handle: '3-m' },
    { name: 'Hermex',    handle: 'hermex' },
    { name: 'Amanco',    handle: 'amanco' }
  ];

  function buildCategoriesHTML() {
    var items = CATEGORIES.map(function(c) {
      return '<a class="fm-cat-item" href="/collections/' + c.handle + '">'
        + '<span class="fm-cat-badge">' + c.code + '</span>'
        + '<span class="fm-cat-info">'
        + '<span class="fm-cat-name">' + c.name + '</span>'
        + '<span class="fm-cat-count">' + c.count + ' productos</span>'
        + '</span></a>';
    }).join('');
    return '<div class="fm-panel-inner">'
      + '<p class="fm-section-title">Explorar departamentos</p>'
      + '<div class="fm-cats">' + items + '</div>'
      + '<a class="fm-view-all" href="/collections/all">Ver todos los productos &rarr;</a>'
      + '</div>';
  }

  function buildBrandsHTML() {
    var chips = BRANDS.map(function(b) {
      return '<a class="fm-brand-chip" href="/collections/' + b.handle + '">' + b.name + '</a>';
    }).join('');
    return '<div class="fm-panel-inner">'
      + '<p class="fm-section-title">Marcas disponibles</p>'
      + '<div class="fm-brands">' + chips + '</div>'
      + '<a class="fm-view-all" href="/collections/all-brands">Ver todas las marcas &rarr;</a>'
      + '</div>';
  }

  var activePanel = null;
  var hideTimer = null;

  function hideAll() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function() {
      document.querySelectorAll('.fm-panel').forEach(function(p) {
        p.style.opacity = '0';
        p.style.pointerEvents = 'none';
        p.style.transform = 'translateY(-6px)';
      });
      activePanel = null;
    }, 150);
  }

  function showPanel(panel, li) {
    clearTimeout(hideTimer);
    if (activePanel && activePanel !== panel) {
      activePanel.style.opacity = '0';
      activePanel.style.pointerEvents = 'none';
    }
    var rect = li.getBoundingClientRect();
    panel.style.top = rect.bottom + 'px';
    panel.style.opacity = '1';
    panel.style.pointerEvents = 'auto';
    panel.style.transform = 'translateY(0)';
    activePanel = panel;
  }

  function createPanel(html) {
    var panel = document.createElement('div');
    panel.className = 'fm-panel';
    panel.innerHTML = html;
    panel.style.cssText = [
      'position:fixed',
      'left:0',
      'right:0',
      'top:0',
      'z-index:99999',
      'background:#fff',
      'box-shadow:0 8px 32px rgba(0,0,0,.18)',
      'border-top:3px solid #ff9933',
      'opacity:0',
      'pointer-events:none',
      'transform:translateY(-6px)',
      'transition:opacity .18s,transform .18s',
      'padding:1.25rem 2rem'
    ].join(';');
    document.body.appendChild(panel);
    panel.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
    panel.addEventListener('mouseleave', hideAll);
    return panel;
  }

  function init() {
    /* Selectors amplios para cubrir cualquier variante del tema */
    var allLinks = document.querySelectorAll(
      'header-menu a, .header__inline-menu a, .list-menu--inline a, nav a'
    );

    allLinks.forEach(function(a) {
      var text = (a.textContent || '').toLowerCase().trim();
      var isProds  = text === 'productos' || text === 'todos los productos' || text.includes('producto');
      var isBrands = text === 'marcas'    || text === 'todas las marcas'    || text.includes('marca');
      if (!isProds && !isBrands) return;

      var li = a.closest('li');
      if (!li || li.dataset.fmDone) return;
      li.dataset.fmDone = '1';

      var html  = isProds ? buildCategoriesHTML() : buildBrandsHTML();
      var panel = createPanel(html);

      /* Caret visual */
      a.style.cursor = 'pointer';
      var caret = document.createElement('span');
      caret.textContent = ' ▾';
      caret.className = 'fm-caret';
      a.appendChild(caret);

      li.addEventListener('mouseenter', function() { showPanel(panel, li); });
      li.addEventListener('mouseleave', hideAll);
    });
  }

  /* Ejecutar tras carga completa con fallback de 800ms */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 100); });
  } else {
    setTimeout(init, 100);
  }

})();